<template>
  <div class="wg-row">
    <!-- Filtro a tre colonne -->
    <div
      id="list-filter-btns"
      class="wg-row project-list-filter-btns wg-md-none"
    >
      <div
        v-for="(filterBtn, index) in filterBtns"
        :key="index"
        :class="'wg-col wg-xs-' + (12 / statusList.length)"
      >
        <div
          :id="'list-filter-btn-' + filterBtn.id"
          :class="{ selected: selectedStatus === filterBtn.id }"
          @click="changeStatus(filterBtn.id)"
        >
          {{ filterBtn.label }}
        </div>
      </div>
    </div>
    <!-- Columns headers -->
    <div
      id="list-cols-labels"
      class="wg-row list-cols-labels"
      style="align-items:center;"
    >
      <div
        v-for="(filterBtn, index) in filterBtns"
        :key="index"
        :class="'wg-col wg-xs-' + (12 / statusList.length) + ' display-flex com-anm22-app-text-l'"
        style="font-weight:bold;justify-content:center;"
      >
        {{ filterBtn.label }}
      </div>
    </div>
    <div class="wg-row">
      <div
        id="status-projects-list-waiting"
        :class="'wg-col wg-xs-12 wg-md-' + (12 / statusList.length) + ' status-projects-list com-anm22-app-scrolling-panel'"
        v-show="selectedStatus === 'waiting' || windowWidth > 991"
        style="padding:0 5px;"
        @scroll="getNextProjects('waiting')"
      >
        <template v-if="separateUrgent">
          <project-bar
            v-for="pdata in waitingProjectsData[0]"
            :key="'waiting-u-' + pdata.id"
            :projectData="pdata"
            :view="'cols'"
          ></project-bar>
          <div
            v-if="
              waitingProjectsData[0].length && waitingProjectsData[1].length
            "
            class="separator"
          ></div>
          <project-bar
            v-for="pdata in waitingProjectsData[1]"
            :key="'waiting-' + pdata.id"
            :projectData="pdata"
            :view="'cols'"
          ></project-bar>
        </template>
        <project-bar
          v-else
          v-for="pdata in waitingProjectsData.slice(
            0,
            projectsListsLimit['waiting']
          )"
          :key="'waiting-' + pdata.id"
          :projectData="pdata"
          :view="'cols'"
        ></project-bar>
      </div>
      <div
        id="status-projects-list-running"
        :class="'wg-col wg-xs-12 wg-md-' + (12 / statusList.length) + ' status-projects-list com-anm22-app-scrolling-panel'"
        v-show="selectedStatus === 'running' || windowWidth > 991"
        style="padding:0 5px;"
        @scroll="getNextProjects('running')"
      >
        <template v-if="separateUrgent">
          <project-bar
            v-for="pdata in runningProjectsData['labels'][0]"
            :key="'running-u-' + pdata.id"
            :projectData="pdata"
            :view="'cols'"
          ></project-bar>
          <div
            v-if="
              runningProjectsData['labels'][0].length &&
                runningProjectsData['labels'][1].length
            "
            class="separator"
          ></div>
          <project-bar
            v-for="pdata in runningProjectsData['labels'][1]"
            :key="'running-' + pdata.id"
            :projectData="pdata"
            :view="'cols'"
          ></project-bar>
        </template>
        <project-bar
          v-else-if="runningProjectsData && runningProjectsData['labels']"
          v-for="pdata in runningProjectsData['labels'].slice(
            0,
            projectsListsLimit['running']
          )"
          :key="'running-' + pdata.id"
          :projectData="pdata"
          :view="'cols'"
        ></project-bar>
      </div>
      <div
        id="status-projects-list-running"
        :class="'wg-col wg-xs-12 wg-md-' + (12 / statusList.length) + ' status-projects-list com-anm22-app-scrolling-panel'"
        v-show="selectedStatus === 'running' || windowWidth > 991"
        style="padding:0 5px;"
        @scroll="getNextProjects('running')"
      >
        <template v-if="separateUrgent">
          <project-bar
            v-for="pdata in runningProjectsData['labelprinting'][0]"
            :key="'running-u-' + pdata.id"
            :projectData="pdata"
            :view="'cols'"
          ></project-bar>
          <div
            v-if="
              runningProjectsData['labelprinting'][0].length &&
                runningProjectsData['labelprinting'][1].length
            "
            class="separator"
          ></div>
          <project-bar
            v-for="pdata in runningProjectsData['labelprinting'][1]"
            :key="'running-' + pdata.id"
            :projectData="pdata"
            :view="'cols'"
          ></project-bar>
        </template>
        <project-bar
          v-else-if="runningProjectsData && runningProjectsData['labelprinting']"
          v-for="pdata in runningProjectsData['labelprinting'].slice(
            0,
            projectsListsLimit['running']
          )"
          :key="'running-' + pdata.id"
          :projectData="pdata"
          :view="'cols'"
        ></project-bar>
      </div>
      <div
        id="status-projects-list-completed"
        :class="'wg-col wg-xs-12 wg-md-' + (12 / statusList.length) + ' status-projects-list com-anm22-app-scrolling-panel'"
        v-show="selectedStatus === 'completed' || windowWidth > 991"
        style="padding:0 5px;"
        @scroll="getNextProjects('completed')"
      >
        <project-bar
          v-for="pdata in completedProjectsData.slice(
            0,
            projectsListsLimit['completed']
          )"
          :key="'completed-' + pdata.id"
          :projectData="pdata"
          :view="'cols'"
        ></project-bar>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ProjectBar from "../project/ProjectBar.vue";

export default {
  components: {
    ProjectBar,
  },
  props: {
    projectsData: {
      type: Array,
      required: true,
    },
    customView: {
      type: Object,
      required: true,
      default: {
        id: null,
        type: "jobs",
        jobs: [],
      }
    },
    sortingFunctionGenerator: {
      type: Function,
      required: true,
    },
    separateUrgent: {
      type: Boolean,
      default: false,
    },
    orderingField: {
      type: String,
      default: "deadline",
    },
    orderingDir: {
      type: String,
      default: "ASC",
    },
  },
  data() {
    return {
      selectedStatus:
        this.$anm22.getCookie("tk_p_status") !== ""
          ? this.$anm22.getCookie("tk_p_status")
          : "running",
      projectsListLimit: 20,
      projectsListsLimit: {},
    };
  },
  computed: {
    ...mapState({
      lang: (state) => state.lang,
      user: (state) => state.auth.user,
      windowWidth: (state) => state.windowWidth,
      windowHeight: (state) => state.windowHeight,
    }),
    viewJobs() {
      return this.customView.jobs;
    },
    statusList() {
      let statusList = ["waiting"];
      statusList.push(...this.viewJobs);
      statusList.push("completed");
      return statusList;
    },
    waitingProjectsData() {
      let waitingProjectsData = [];
      let i, job;
      this.projectsData.forEach((p) => {
        // Check if the projects contains task associated with required jobs
        let jobFound = false;
        for (i = 0; i < this.viewJobs.length; i++) {
          job = this.viewJobs[i];
          if (p.jobs[job] && p.jobs[job].ready) {
            jobFound = true;

            // Check the status of the job
            if (p.jobs[job].status > 1) {
              return false;
            }
          }
        }
        if (!jobFound) {
          return false;
        }
        if (this.separateUrgent) {
          if (p.urgent) {
            waitingProjectsData[0].push(p);
          } else {
            waitingProjectsData[1].push(p);
          }
        } else {
          waitingProjectsData.push(p);
        }
      });

      // List sorting
      if (this.separateUrgent) {
        waitingProjectsData[0] = waitingProjectsData[0].sort(
          this.sortingFunctionGenerator(this.orderingField, this.orderingDir)
        );
        waitingProjectsData[1] = waitingProjectsData[1].sort(
          this.sortingFunctionGenerator(this.orderingField, this.orderingDir)
        );
      } else {
        waitingProjectsData = waitingProjectsData.sort(
          this.sortingFunctionGenerator(this.orderingField, this.orderingDir)
        );
      }

      return waitingProjectsData;
    },
    runningProjectsData() {
      let runningProjectsData = {};
      let i, j, p, job, lastNotCompletedJobFound, oneTaskStarted;
      this.viewJobs.forEach((job) => {
        if (this.separateUrgent) {
          runningProjectsData[job] = [[], []];
        } else {
          runningProjectsData[job] = [];
        }
      });
      for (i = 0; i < this.projectsData.length; i++) {
        p = this.projectsData[i];
        oneTaskStarted = false;
        lastNotCompletedJobFound = null;
        if (p.status !== 2) {
          continue;
        }
        for (j = 0; j < this.viewJobs.length; j++) {
          job = this.viewJobs[j];
          if (p.jobs[job] && p.jobs[job].ready) {
            if ((oneTaskStarted && p.jobs[job].status == 1) || p.jobs[job].status == 2) {
              p.status = 2;
              if (this.separateUrgent) {
                if (p.urgent) {
                  runningProjectsData[job][0].push(p);
                } else {
                  runningProjectsData[job][1].push(p);
                }
              } else {
                runningProjectsData[job].push(p);
              }
              break;
            }
            if (p.jobs[job].status == 3) {
              oneTaskStarted = true;
              if (lastNotCompletedJobFound) {
                console.log("Skipped job");
                p.codeName = "↪️" + p.codeName;
                if (this.separateUrgent) {
                  if (p.urgent) {
                    runningProjectsData[job][0].push(p);
                  } else {
                    runningProjectsData[job][1].push(p);
                  }
                } else {
                  runningProjectsData[job].push(p);
                }
              }
            } else {
              lastNotCompletedJobFound = job;
            }
          }
        }
      }

      // List sorting
      this.viewJobs.forEach((job) => {
        if (this.separateUrgent) {
          runningProjectsData[job][0] = runningProjectsData[job][0].sort(
            this.sortingFunctionGenerator(this.orderingField, this.orderingDir)
          );
          runningProjectsData[job][1] = runningProjectsData[job][1].sort(
            this.sortingFunctionGenerator(this.orderingField, this.orderingDir)
          );
        } else {
          runningProjectsData[job] = runningProjectsData[job].sort(
            this.sortingFunctionGenerator(this.orderingField, this.orderingDir)
          );
        }
      });

      return runningProjectsData;
    },
    completedProjectsData() {
      return this.projectsData
        .filter((p) => {
          // Check if the projects contains task associated with required jobs
          let jobFound = false;
          for (i = 0; i < this.viewJobs.length; i++) {
            job = this.viewJobs[i];
            if (p.jobs[job] && p.jobs[job].ready) {
              jobFound = true;
            }
          }
          if (!jobFound) {
            return false;
          }

          // The completed project status is more important than the single task status
          if (p.status === 3 || p.status === 4 || p.status === 5) {
            return true;
          }

          // Check the single task status
          let i, job;
          for (i = 0; i < this.viewJobs.length; i++) {
            job = this.viewJobs[i];
            if (p.jobs[job] && p.jobs[job].ready) {
              jobFound = true;
            }
            if (
              p.jobs[job] &&
              (p.jobs[job].status == 1 || p.jobs[job].status == 2)
            ) {
              return false;
            }
          }
          p.status = 3;
          return true;
        })
        .sort(
          this.sortingFunctionGenerator(this.orderingField, this.orderingDir)
        );
    },
    filterBtns() {
      return [
        {
          id: "waiting",
          label: this.$anm22.strLang(this.lang, "Waiting", "In attesa"),
        },
        {
          id: "running",
          label: this.$anm22.strLang(this.lang, "Running", "In corso"),
        },
        {
          id: "printing",
          label: this.$anm22.strLang(this.lang, "To print", "Da stampare"),
        },
        {
          id: "completed",
          label: this.$anm22.strLang(this.lang, "Completed", "Completati"),
        },
      ];
    },
  },
  methods: {
    changeStatus(status) {
      this.selectedStatus = status;
      this.$anm22.setCookie("tk_p_status", status, 31536000);
    },
    getNextProjects(statusId) {
      const itemsNum = this.projectsListLimit;
      let bottomOfList =
        document.getElementById("status-projects-list-" + statusId).scrollTop +
          document.getElementById("status-projects-list-" + statusId)
            .clientHeight >=
        this.projectsListsLimit[statusId] * 43;
      if (bottomOfList) {
        this.projectsListsLimit[statusId] += itemsNum;
        console.log("Loading next projects...");
        this.$forceUpdate();
      }
    },
    checkListLimitAfterResize() {
      window.addEventListener(
        "resize",
        (event) => {
          if (window.innerHeight / 43 >= this.projectsListLimit) {
            this.projectsListLimit = Math.round(window.innerHeight / 43);
            console.log(
              "Resized kanbann to " + this.projectsListLimit + " items"
            );
          }
          this.statusList.forEach((status) => {
            if (this.projectsListsLimit[status] < this.projectsListLimit) {
              this.projectsListsLimit[status] = this.projectsListLimit;
            }
          });
        },
        true
      );
    },
  },
  created() {
    if (window.innerHeight / 43 >= this.projectsListLimit) {
      this.projectsListLimit = Math.round(window.innerHeight / 43);
      console.log("Resized kanbann to " + this.projectsListLimit + " items");
    }
    this.statusList.forEach((status) => {
      this.projectsListsLimit[status] = this.projectsListLimit;
    });
  },
};
</script>

<style lang="scss" scoped>
.separator {
  background-color: #fff;
  box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.03);
  border-bottom: 2px solid #ddd;
  margin-bottom: 8px;
  height: 1px;
}
.none {
  display: none;
}
.status-projects-list {
  max-height: calc(100vh - 270px);
}
@media screen and (max-width: 990px) {
  .status-projects-list {
    max-height: calc(100vh - 312px);
  }
}
</style>
